import styled, { css } from 'styled-components'

const selectedButtonStyles = css`
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  color: ${({ theme }) => theme.forecast.defaultText};
  font-weight: bold;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }

  &:active {
    background-color: ${({ theme }) => theme.forecast.activeButton};
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

export const NavbarButtonContainer = styled.div<{ $isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
  color: ${({ theme }) => theme.forecast.activeText};
  background-color: ${({ theme }) => theme.forecast.background2_5};
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.background3};
    transform: scale(1.05);
  }

  &:active {
    background-color: ${({ theme }) => theme.forecast.background4};
    transform: scale(0.95);
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.forecast.border2};
    outline-offset: 2px;
  }

  ${({ $isSelected }) => $isSelected && selectedButtonStyles}
`
